import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { LocationsFilterOption } from '../models/locations-filter-option';
import { LocationsRegisterListItem } from '../models/locations-register-results.model';

const area = 'Locations Register';

export const locationsRegisterAdapterActions = createRegisterActions<LocationsRegisterListItem>(area);

export const createLocation = createAction(`[${area}] Create Location`);

export const locationsRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: LocationsFilterOption[] }>()
);

export const loadLocationsSuccess = createAction(`[${area}] Load Locations Success`);

export const loadLocationsFailure = createAction(`[${area}] Load Locations Failure`);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
